export default __webpack_public_path__ + "static/media/ab.7354867a.png";